<template>
    <div>
        <config-main-title>
            Unidades / Centros de Custo
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6">
                <az-input
                    icon="fa-solid fa-magnifying-glass"
                    placeholder="Pesquisar..."
                    v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="criar_unidade()">Incluir Unidade</button>
            </div>
        </div>

        <div v-if="!dados || !lista_exibicao.length">
            <az-empty-state msg="Nenhum prestador cadastrado." action="Incluir Primeiro Prestador" :method="criar_unidade" />
        </div>

        <ul class="list-group mb-3">
            <template v-for="(unidade, iu) in filtrar_ativos(lista_exibicao)">
                <li class="list-group-item list-group-item-primary mb-2 dashcard" :key="'u' + iu" v-if="true">
                    <div class="d-flex justify-content-between">
                        <div>
                            <a href="#" @click.prevent="unidade.exibir_detalhe = !unidade.exibir_detalhe" class="card-link mr-3">
                                <i class="far fa-square" v-if="!unidade.centro_custos.length && !unidade.recepcaos.length"></i>
                                <i class="far fa-plus-square" v-else-if="!unidade.exibir_detalhe"></i>
                                <i class="far fa-minus-square" v-else-if="unidade.exibir_detalhe"></i>
                            </a>
                            <i class="far fa-building fa-fw mr-3" data-toggle="tooltip" data-placement="top" title="Unidade"></i>
                            <span class="badge badge-secondary mr-3">
                                #{{ unidade.id_unidade_operacao }}
                            </span>
                            <a href="#" @click.prevent="editar_unidade(unidade)" class="card-link">
                                {{ unidade.search }}
                                <span class="badge badge-light" v-if="unidade.st_sigla">
                                    {{ unidade.st_sigla }}
                                </span>
                            </a>

                            <span v-if="unidade.fl_nota_fiscal" class="badge badge-dark ml-3" title="Emissão de NF.">
                                {{ unidade.fl_nota_fiscal_eletronica ? 'NFe' : 'NF' }}
                                <span v-if="unidade.id_unidade_operacao_nf" class="ml-1">
                                    #{{ unidade.id_unidade_operacao_nf }}
                                </span>
                            </span>

                            <a :href="unidade.endereco.st_map_link" class="ml-3" v-if="unidade.endereco && unidade.endereco.st_map_link" target="_blank" title="Endereço Google Maps.">
                                <i class="fas fa-map-marker-alt"></i>
                            </a>
                        </div>
                        <div class="d-flex">
                            <div v-if="unidade.js_classes">
                                <span class="badge badge-success mr-2" v-for="(tag, itx) in unidade.js_classes" :key="itx">
                                    {{ tag }}
                                </span>
                            </div>
                            <div class="mr-2">
                                <span class="badge badge-primary">
                                    {{ unidade.centro_custos.length }}
                                </span>
                            </div>
                            <a href="#" class="text-success mr-2" @click.prevent="criar_centro_custo(unidade)"
                                v-if="viewMode == 'A'"
                                data-toggle="tooltip" data-placement="top" title="Incluir Centro de Custo">
                                <i class="fas fa-plus-circle"></i>
                            </a>
                            <div class="custom-control custom-switch ml-2" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" :id="'unidade' + iu"
                                    v-model="unidade.fl_ativo" @change="toggle_status('unidade_operacaos', unidade)">
                                <label class="custom-control-label" :for="'unidade' + iu"></label>
                            </div>
                        </div>
                    </div>
                </li>

                <ul class="list-group ml-3" :key="'c' + iu" v-if="unidade.exibir_detalhe">
                    <template v-for="(recep, irec) in filtrar_ativos(unidade.recepcaos)">
                        <li class="list-group-item list-group-item-secondary mb-2 dashcard"  :key="'u' + iu + '-r' + irec" v-if="true">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <i class="fas fa-concierge-bell fa-fw mr-3" data-toggle="tooltip" data-placement="top" title="Recepção"></i>
                                    <span v-if="recep.mae" class="text-muted">
                                        {{ recep.mae.search }}
                                        <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                    </span>
                                    <a href="#" @click.prevent="editar_centro_custo(unidade, recep)" class="card-link">
                                        {{ recep.search }}
                                    </a>
                                    <span class="badge badge-secondary ml-2" v-if="recep.st_sigla">
                                        {{ recep.st_sigla }}
                                    </span>
                                </div>
                                <div class="custom-control custom-switch ml-2" v-if="viewMode == 'T'">
                                    <input type="checkbox" class="custom-control-input" :id="'recep' + iu + '-' + irec"
                                        v-model="recep.fl_ativo" @change="toggle_status('recepcaos', recep)">
                                    <label class="custom-control-label" :for="'recep' + iu + '-' + irec"></label>
                                </div>
                            </div>
                        </li>
                    </template>
                    <template v-for="(centro, ic) in filtrar_ativos(unidade.centro_custos)">
                        <li class="list-group-item list-group-item-info mb-2 dashcard"  :key="'u' + iu + '-c' + ic" v-if="true">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <a href="#" @click.prevent="centro.exibir_detalhe = !centro.exibir_detalhe" class="card-link mr-3">
                                        <i class="far fa-square" v-if="!centro.locals.length"></i>
                                        <i class="far fa-plus-square" v-else-if="!centro.exibir_detalhe"></i>
                                        <i class="far fa-minus-square" v-else-if="centro.exibir_detalhe"></i>
                                    </a>
                                    <i class="fas fa-funnel-dollar fa-fw mr-3" data-toggle="tooltip" data-placement="top" title="Centro de Custo"></i>
                                    <a href="#" @click.prevent="editar_centro_custo(unidade, centro)" class="card-link">
                                        {{ centro.search }}
                                    </a>
                                </div>
                                <div class="d-flex">
                                    <div class="mr-2">
                                        <span class="badge badge-info">
                                            {{ centro.locals.length }}
                                        </span>
                                    </div>
                                    <a href="#" class="text-success mr-2" @click.prevent="criar_local(centro)"
                                        v-if="viewMode == 'A'"
                                        data-toggle="tooltip" data-placement="top" title="Incluir Local">
                                        <i class="fas fa-plus-circle"></i>
                                    </a>
                                    <div class="custom-control custom-switch ml-2" v-if="viewMode == 'T'">
                                        <input type="checkbox" class="custom-control-input" :id="'centro' + iu + '-' + ic"
                                            v-model="centro.fl_ativo" @change="toggle_status('centro_custos', centro)">
                                        <label class="custom-control-label" :for="'centro' + iu + '-' + ic"></label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <ul class="list-group ml-3" :key="'u' + iu + '-c' + ic + 'l'" v-if="centro.exibir_detalhe">
                            <li class="list-group-item mb-2 dashcard" v-for="(local, il) in filtrar_ativos(centro.locals)" :key="'u' + iu + '-c' + ic + '-l' + il">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <i class="fas fa-door-open fa-fw mr-3" data-toggle="tooltip" data-placement="top" title="Local"></i>
                                        <a href="#" @click.prevent="editar_local(centro, local)" class="card-link">
                                            {{ local.st_local }}
                                        </a>
                                    </div>
                                    <div>
                                        <div class="custom-control custom-switch ml-2" v-if="viewMode == 'T'">
                                            <input type="checkbox" class="custom-control-input" :id="'local' + iu + '-' + ic + '-' + il"
                                                v-model="local.fl_ativo" @change="toggle_status('locals', local)">
                                            <label class="custom-control-label" :for="'local' + iu + '-' + ic + '-' + il"></label>
                                        </div>
                                        <div v-else>
                                            <i class="fa-solid fa-circle-chevron-down fa-fw ml-3" v-if="local.fl_infusao" title="Infusão"></i>
                                            <i class="fa-solid fa-house-medical fa-fw ml-3" v-else-if="local.fl_centro_cirurgico"></i>
                                            <i class="fa-solid fa-bed fa-fw ml-3" v-else-if="local.fl_leito" title="Leito"></i>
                                            <i class="fab fa-product-hunt ml-3" v-else-if="local.fl_sala_paralela" title="Atendimento paralelo."></i>

                                            <i class="fas fa-map ml-3" v-if="local.fl_exibir_mapa_sala" title="Exibir no mapa de sala."></i>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </template>
                </ul>

            </template>
        </ul>

        <pre v-if="1 == 0">{{ dados }}</pre>

        <!-- Modal Unidade -->
        <div class="modal fade" id="unidadeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao_unidade">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Unidade
                            <span class="badge badge-secondary ml-2" v-if="edicao_unidade.id_unidade_operacao">
                                #{{ edicao_unidade.id_unidade_operacao }}
                            </span>
                            <span v-if="edicao_unidade.id_unidade_operacao && edicao_unidade.st_nome" class="ml-3">
                                {{ edicao_unidade.st_nome }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_unidade">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input label="Nome da Unidade" v-model="edicao_unidade.st_nome" required :validate="validate" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-12 col-md-8">
                                        <az-input label="e-mail" v-model="edicao_unidade.st_email" :validate="validate" type="email" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input label="CNES" v-model="edicao_unidade.st_cnes" :validate="validate" type="cnes" />
                                    </div>
                                </div>
                            </div>
                            <div class="col col-12 col-md-6">
                                <div v-if="edicao_unidade.id_unidade_operacao" class="d-flex justify-content-end">
                                    <az-single-image-loader
                                        :single="true"
                                        service="unidade_operacaos"
                                        :arquivo="edicao_unidade.logo"
                                        :parms="{ model_type: 'unidadeOperacao', model_id: edicao_unidade.id_unidade_operacao, public: true }"
                                    ></az-single-image-loader>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input label="Razão Social" v-model="edicao_unidade.st_razao_social" :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input label="CNPJ" type="cnpj" v-model="edicao_unidade.st_cnpj" :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input label="Sigla" v-model="edicao_unidade.st_sigla" :validate="validate" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input label="Nome do Representante" v-model="edicao_unidade.st_nome_representante" :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input label="CPF do Representante" type="cpf" v-model="edicao_unidade.st_cpf" :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input label="Telefone do Representante" v-model="edicao_unidade.st_telefone_representante" :validate="validate" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12 col-md-3">
                                <az-input type="checkbox-group" label="Apenas Administrativa" v-model="edicao_unidade.fl_unidade_adm" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input type="checkbox-group" label="Agenda Online" v-model="edicao_unidade.fl_agenda_online" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input placeholder="Código Emissor APAC..." v-model="edicao_unidade.st_codigo_apac_emissor" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input placeholder="Id Externo..." v-model="edicao_unidade.st_id_externo" :validate="validate" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input type="textarea" rows="3" label="Observações" v-model="edicao_unidade.st_observacoes" />
                            </div>
                        </div>

                        <div class="row" v-if="$store.state.user.id_usuario == 1">
                            <div class="col col-12">
                                <az-input label="Token de Integração (Klingo)" v-model="edicao_unidade.st_klingo_token" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <small class="text-muted">Classificação</small>
                                <multiselect
                                    v-model="edicao_unidade.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <az-sub-title title="Endereço" class="mt-3" />
                        <cadastro-endereco v-model="edicao_unidade.endereco" :validate="validate" :map_link="true" />

                        <az-input 
                            type="checkbox-group"
                            label="Não exibir o endereço acima na comunicação para o paciente." 
                            v-model="edicao_unidade.fl_endereco_comunic_alternativo" />

                        <az-input
                            type="textarea"
                            rows="3"
                            label="Endereço Alternativo"
                            placeholder="Nenhum Endereço alternativo..."
                            v-if="edicao_unidade.fl_endereco_comunic_alternativo"
                            v-model="edicao_unidade.st_endereco_alternativo" />

                        <az-input
                            class="mt-3"
                            type="textarea"
                            rows="3"
                            label="Texto para o E-mail da Marcação"
                            placeholder="Nenhum..."
                            v-model="edicao_unidade.st_texto_marcacao" />

                        <az-sub-title title="Telefones" class="mt-3" />
                        <cadastro-telefones v-model="edicao_unidade.telefone_unidade_operacaos" :validate="validate" />

                        <az-sub-title title="Rodapé de Impressão de Documentos (Receitas, Requisições, Atestados...)" class="mt-3" />
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    rows="3"
                                    placeholder="Padrão..."
                                    v-model="edicao_unidade.st_impressao_rodape" />
                            </div>
                        </div>

                        <template v-if="tem_ipsign">
                            <az-sub-title title="Configurações IPSign" class="mt-3" />
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Base URL"
                                        placeholder="Padrão..."
                                        v-model="edicao_unidade.st_ipsign_baseurl" />
                                </div>

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Token"
                                        placeholder="Padrão..."
                                        v-model="edicao_unidade.st_ipsign_token" />
                                </div>
                            </div>
                        </template>

                        <az-sub-title title="Configurações da Nota Fiscal" class="mt-3" />
                        <div class="row mt-3">
                            <div class="col col-12 col-md-6">
                                <az-input type="checkbox-group" label="Habilitar Emissão de Nota Fiscal" v-model="edicao_unidade.fl_nota_fiscal" />
                            </div>
                        </div>

                        <template v-if="edicao_unidade.fl_nota_fiscal">
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label   ="Emitir a NF Particular por Outra Unidade:"
                                        type="select"
                                        placeholder="Não..."
                                        :optionsList="$util.unidades_com_tags(false, false).filter(item => item.id_unidade_operacao != edicao_unidade.id_unidade_operacao)"
                                        optionsData="id_unidade_operacao"
                                        v-model="edicao_unidade.id_unidade_operacao_nf" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input label="Inscrição Municipal"
                                        v-model="edicao_unidade.st_inscricao_municipal"
                                        :validate="edicao_unidade.fl_nota_fiscal"
                                        required />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input label="Série" v-model="edicao_unidade.st_rps_serie" :validate="edicao_unidade.fl_nota_fiscal" required />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                      label="Tipo"
                                      type="select"
                                      optionsMode="json"
                                      :optionsList="rps_tipo"
                                      optionsData="id"
                                      :validate="edicao_unidade.fl_nota_fiscal" required
                                      v-model="edicao_unidade.st_rps_tipo"
                                    />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                      label="Natureza da operação"
                                      type="select"
                                      optionsMode="json"
                                      :optionsList="natureza_operacao"
                                      optionsData="id"
                                      :validate="edicao_unidade.fl_nota_fiscal" required
                                      v-model="edicao_unidade.st_natureza_operacao"
                                    />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                      type="money"
                                      :label="edicao_unidade.ch_optante_simples_nacional == '3' ? 'Alíquota do Simples Nacional (%)' : 'Aliquota ISS Particular'"
                                      v-model="edicao_unidade.dc_iss_particular" />
                                </div>

                                <div class="col col-12 col-md-3 mt-4" v-if="edicao_unidade.ch_nfse_servico != '5'" >
                                    <az-input type="checkbox-group" label="Optante pelo simples nacional" v-model="edicao_unidade.fl_optante_simples_nacional" />
                                </div>

                                <div class="col col-12 col-md-3" v-else>
                                    <az-input
                                      label="Optante pelo simples nacional"
                                      type="select"
                                      optionsMode="json"
                                      :optionsList="op_simples_nacional"
                                      optionsData="id"
                                      :validate="edicao_unidade.fl_nota_fiscal" required
                                      v-model="edicao_unidade.ch_optante_simples_nacional"
                                    />
                                </div>
                            </div>

                            <div class="row" v-if="edicao_unidade.ch_optante_simples_nacional == '3'">
                                <div class="col col-12 col-md-12">
                                    <az-input
                                      label="Regime especial de tributação (Simples Nacional)"
                                      type="select"
                                      optionsMode="json"
                                      :optionsList="regime_tributacao_sn"
                                      optionsData="id"
                                      :validate="edicao_unidade.fl_nota_fiscal"
                                      v-model="edicao_unidade.ch_regime_especial_tributacao_sn"
                                    />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input label="Item na lista de serviços" v-model="edicao_unidade.st_item_list_servico" :validate="edicao_unidade.fl_nota_fiscal" required/>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input label="Código CNAE"
                                        v-model="edicao_unidade.st_codigo_cnae"
                                        :validate="edicao_unidade.fl_nota_fiscal"
                                        required>
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="edicao_unidade.cnaes && edicao_unidade.cnaes.length" title="CNAEs cadastrados.">
                                                <span class="input-group-text" id="basic-addon2">+{{ edicao_unidade.cnaes.length }}</span>
                                            </div>
                                            <div class="input-group-append" v-if="edicao_unidade.id_unidade_operacao">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="editar_cnaes (edicao_unidade)">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input label="Código Tributação Município" v-model="edicao_unidade.st_codigo_tributacao_municipio" :validate="validate" required />
                                </div>
                            </div>

                            <div class="row" v-if="edicao_unidade.endereco && edicao_unidade.endereco.cidade && edicao_unidade.endereco.cidade.st_codigo_ibge">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                      label="Regime especial de tributação"
                                      type="select"
                                      optionsMode="json"
                                      :optionsList="edicao_unidade.ch_nfse_servico == '5' ? regime_tributacao_novo : regime_tributacao"
                                      optionsData="id"
                                      :validate="edicao_unidade.fl_nota_fiscal"
                                      v-model="edicao_unidade.ch_regime_especial_tributacao"
                                    />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                      label="Serviço de emissão de NFS-e"
                                      type="select"
                                      optionsMode="json"
                                      :optionsList="servico_nfse"
                                      optionsData="id"
                                      :validate="edicao_unidade.fl_nota_fiscal"
                                      v-model="edicao_unidade.ch_nfse_servico"
                                    />
                                </div>
                            </div>

                            <div class="row" v-if="edicao_unidade.ch_nfse_servico == '1'">
                                <div class="col col-12 col-md-12">
                                    <az-input
                                      label="Código de Situação Tributária (CST)"
                                      type="select"
                                      optionsMode="json"
                                      :optionsList="situacao_tributaria"
                                      optionsData="id"
                                      :validate="edicao_unidade.fl_nota_fiscal" 
                                      v-model="edicao_unidade.st_codigo_situacao_tributaria"
                                    />
                                </div>
                            </div>

                            <div class="row" v-if="edicao_unidade.ch_nfse_servico != '1'">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                      label="Código NBS"
                                      :validate="edicao_unidade.fl_nota_fiscal" 
                                      v-model="edicao_unidade.st_codigo_nbs"
                                    />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                      label="Código de Situação Tributária (CST)"
                                      :validate="edicao_unidade.fl_nota_fiscal" 
                                      :maxlength="3"
                                      v-model="edicao_unidade.st_codigo_situacao_tributaria"
                                    />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                      label="Classificação Tributária"
                                      :validate="edicao_unidade.fl_nota_fiscal" 
                                      v-model="edicao_unidade.st_classificacao_tributaria"
                                    />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                      label="Indicador de Operação"
                                      :validate="edicao_unidade.fl_nota_fiscal" 
                                      v-model="edicao_unidade.st_indicador_operacao"
                                    />
                                </div>
                            </div>

                            <div class="row" v-if="edicao_unidade.ch_nfse_servico == '5'">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                      type="money"
                                      label="Percentual aproximado dos tributos federais"
                                      v-model="edicao_unidade.dc_perc_tributos_federais" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                      type="money"
                                      label="Aliquota PIS (%)"
                                      v-model="edicao_unidade.dc_aliquota_pis" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                      type="money"
                                      label="Aliquota COFINS (%)"
                                      v-model="edicao_unidade.dc_aliquota_cofins" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-12">
                                    <az-input 
                                        label="Discriminação do Serviço" 
                                        type="textarea"
                                        rows="3"
                                        v-model="edicao_unidade.st_discriminacao_servico" 
                                        :validate="edicao_unidade.fl_nota_fiscal" 
                                        required />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-12">
                                    <az-input 
                                        type="textarea" 
                                        label="Observações importantes para o RPS" 
                                        rows="3" 
                                        v-model="edicao_unidade.st_rps_obs" 
                                        :validate="edicao_unidade.fl_nota_fiscal" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-3 mt-4">
                                     <az-input type="checkbox-group" label="Contador Número da NF" v-model="edicao_unidade.fl_contador_numero" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input label="Próximo Número da NF" v-model="edicao_unidade.st_contador_numero" :validate="validate" :edicao="edicao_unidade.fl_contador_numero" />
                                </div>
                                <div class="col col-12 col-md-3 mt-4">
                                     <az-input type="checkbox-group" label="Contador Número do Lote" v-model="edicao_unidade.fl_contador_lote" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input label="Próximo Número de Lote" v-model="edicao_unidade.st_contador_lote" :validate="validate" :edicao="edicao_unidade.fl_contador_lote" />
                                </div>
                            </div>


                            <div class="row mt-3">
                                <div class="col col-12 col-md-6">
                                    <az-input type="checkbox-group" label="Habilitar Emissão de Nota Fiscal Eletrônica" v-model="edicao_unidade.fl_nota_fiscal_eletronica" />
                                </div>
                            </div>


                            <template v-if="edicao_unidade.fl_nota_fiscal_eletronica">
                                
                                <template v-if="edicao_unidade.endereco && edicao_unidade.endereco.cidade && !edicao_unidade.endereco.cidade.st_codigo_ibge">
                                    <div class="row mt-2">
                                        <div class="col col-12">
                                            <span class="text-danger">Código IBGE não informado para a a cidade <strong>{{edicao_unidade.endereco.cidade.st_cidade}}</strong>. Entre em contato com o suporte do Klingo.</span>
                                        </div>
                                    </div>
                                </template>
                                
                                <!-- <template v-if="edicao_unidade.endereco && edicao_unidade.endereco.cidade && edicao_unidade.endereco.cidade.st_codigo_ibge == '2919207'"> -->
                                <template v-else-if="edicao_unidade.endereco && edicao_unidade.endereco.cidade && edicao_unidade.ch_nfse_servico == '1'">

                                <div class="row">

                                    <div class="col col-12 col-md-3">
                                        <az-input label="Login no sistema JR PowerP" v-model="edicao_unidade.st_powerp_login" required :validate="validate" :edicao="edicao_unidade.fl_nota_fiscal_eletronica" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input type="password" label="Senha no sistema JR PowerP" v-model="edicao_unidade.st_powerp_senha" required :validate="validate" :edicao="edicao_unidade.fl_nota_fiscal_eletronica" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input label="Domínio no sistema JR PowerP" v-model="edicao_unidade.st_powerp_dominio" required :validate="validate" :edicao="edicao_unidade.fl_nota_fiscal_eletronica" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input label="Unidade no sistema JR PowerP" v-model="edicao_unidade.st_powerp_unidade" required :validate="validate" :edicao="edicao_unidade.fl_nota_fiscal_eletronica" />
                                    </div>

                                </div>


                                </template>

                                <template v-else>
                                    <div class="row mt-3">
                                        <div class="col col-12 col-md-12">
                                            <p>
                                                Carregar Certificado Digital tipo A1. O certificado A1 é um arquivo com extensão PFX.<br>
                                                Você não deve fornecer sua senha do certificado para terceiros. Ela é a sua segurança no momento da assinatura de documentos.
                                                Ela será usada apenas para validar o certificado durante seu carregamento e para assinar documentos.
                                            </p>

                                            <hr>
                                        </div>
                                    </div>

                                    <small class="form-text text-muted text-nowrap text-truncate">
                                        Senha do Certificado
                                    </small>

                                    <div class="row">
                                        <div class="col col-4 col-md-4">
                                            <input
                                                type="text"
                                                id="password"
                                                style="-webkit-text-security: disc;"
                                                v-model="chave"
                                                autocomplete="off"
                                                class="form form-control" />
                                        </div>
                                        <div class="col col-4 col-md-4" v-if="chave">
                                            <az-single-image-loader
                                                chave="pfx"
                                                :titulo2="edicao_unidade.tem_certificado ? 'Atualizar Certificado' : 'Carregar Certificado'"
                                                :titulo="'Carregar Certificado'"
                                                :single="true"
                                                :parms="{ model_type: 'unidadeOperacao', model_id: edicao_unidade.id_unidade_operacao,  tipo_especial: 'certificado_nfse', certificado_chave: chave, tipo_servico_nfse: edicao_unidade.ch_nfse_servico  }"
                                                extension="pfx"
                                                mimetype="application/x-pkcs12"
                                                service="medicos"
                                                :blockcam="true" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-4 col-md-4 mt mt-3" v-if="edicao_unidade.tem_certificado">
                                            <button class="btn btn-outline-primary mb-2" @click="exibir_dados_certificado = !exibir_dados_certificado">
                                                <i class="fas fa-user-check mr-2"></i>
                                                Verificar certificado
                                            </button>
                                        </div>
                                    </div>

                                    <div class="row" v-if="exibir_dados_certificado">
                                        <pre class="col col-12 mt-3 alert alert-info">{{ edicao_unidade.st_dados_certificado }}</pre>
                                    </div>
                                </template>

                            </template>

                        </template>

                        <template v-else>
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                      type="money"
                                      label="Aliquota ISS"
                                      v-model="edicao_unidade.dc_iss_particular" />
                                </div>
                            </div>
                        </template>

                        <div v-if="edicao_unidade.campos_customizados && edicao_unidade.campos_customizados.js_campos.length" class="row mt-3">
                            <div class="col col-12">
                                <az-sub-title :title="edicao_unidade.campos_customizados.st_titulo" />
                                <formulario 
                                    :gutters="true" 
                                    v-model="edicao_unidade.campos_customizados.js_campos" 
                                    :saved="true" 
                                    mode="fixed"
                                    :validate="validate"
                                    :config="true" />
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" v-if="edicao_unidade.id_unidade_operacao && dados.length > 1 && !edicao_unidade.fl_unidade_adm"
                            @click="lista_procedimentos(edicao_unidade)">
                            <i class="fa fa-ban mr-2" aria-hidden="true"></i>
                            Procedimentos
                        </button>
                        <button type="button" class="btn btn-primary" v-if="edicao_unidade.id_unidade_operacao && dados.length > 1 && !edicao_unidade.fl_unidade_adm"
                            @click="editar_unidade_operacao_planos(edicao_unidade)">Particulares</button>
                        <button type="button" class="btn btn-primary" v-if="edicao_unidade.id_unidade_operacao && dados.length > 1 && !edicao_unidade.fl_unidade_adm"
                            @click="editar_unidade_operadoras(edicao_unidade)">Operadoras</button>
                        <az-audit-log-button model="unidadeOperacao" :id="edicao_unidade.id_unidade_operacao" v-if="edicao_unidade.id_unidade_operacao" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_unidade()">{{ edicao_unidade.id_unidade ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Centro de Custo -->
        <div class="modal fade" id="centroModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total" v-if="edicao_unidade && edicao_centro_custo">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ edicao_unidade.search }} /
                            {{ edicao_centro_custo.tipo == 'R' || edicao_centro_custo.id_recepcao ? 'Recepção' : 'Centro de Custo' }}
                            <span class="badge badge-secondary ml-2" v-if="edicao_centro_custo.id_centro_custo">
                                #{{ edicao_centro_custo.id_centro_custo }}
                            </span>
                            <span class="badge badge-secondary ml-2" v-else-if="edicao_centro_custo.id_recepcao">
                                #{{ edicao_centro_custo.id_recepcao }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_centro_custo">
                        <az-input
                            class="mb-3"
                            label="Incluir"
                            v-if="!edicao_centro_custo.id_centro_custo && !edicao_centro_custo.id_recepcao"
                            type="select"
                            v-model="edicao_centro_custo.tipo"
                            :optionsList="[{id: 'R', search: 'Recepcão'}, {id: 'C', search: 'Centro de Custo'}]"
                            optionsData="id" />

                        <div class="row">
                            <div class="col col-12 col-md-8">
                                <az-input label="Nome" required :validate="validate" v-model="edicao_centro_custo.st_nome" />
                            </div>

                            <div class="col col-12 col-md-2" v-if="( edicao_centro_custo.tipo == 'R' || edicao_centro_custo.id_recepcao )">
                                <az-input label="Sigla" :validate="validate" v-model="edicao_centro_custo.st_sigla" />
                            </div>

                            <div class="col col-12 col-md-2" v-else>
                                <az-input 
                                    label="Solic Apoiado" 
                                    type="checkbox"
                                    :validate="validate" 
                                    v-model="edicao_centro_custo.fl_mov_apoiado" />
                            </div>

                            <div class="col col-12 col-md-2">
                                <az-input label="Id Externo" :validate="validate" v-model="edicao_centro_custo.st_id_externo" />
                            </div>
                        </div>

                        <div class="row" v-if="edicao_centro_custo.id_centro_custo || edicao_centro_custo.tipo == 'C'">
                            <div class="col col-12 col-md-10">
                            </div>

                            <div class="col col-12 col-md-2">
                                <az-input label="Sigla" :validate="validate" v-model="edicao_centro_custo.st_sigla" />
                            </div>
                        </div>

                        <div v-if="edicao_centro_custo && edicao_centro_custo.fl_mov_apoiado" class="mt-3 alert alert-info">
                            Ao marcar a opção "Solic Apoiado", indica que nas solicitações de materiais desse centro de custo, poderá ser informado o apoiado ao qual se destina o material.
                        </div>

                        <div v-if="edicao_centro_custo.id_recepcao">
                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="Token para Painel/Totem"
                                        icon="fa-solid fa-key"
                                        placeholder="Token não definido"
                                        :edicao="false"
                                        v-model="edicao_centro_custo.st_token_painel">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary" type="button" @click="gerar_link_painel()"
                                                    title="Gerar Novo Token" data-toggle="tooltip"
                                                    :disabled="$store.state.loading">
                                                    <i class="fas fa-sync-alt"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-4" v-if="edicao_centro_custo.st_token_painel">
                                    <small class="text-muted">Link do Painel de Chamada</small>
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Gerar..." :value="edicao_centro_custo.link_painel" disabled>
                                        <div class="input-group-append" v-if="edicao_centro_custo.link_painel">
                                            <a class="btn btn-outline-primary" type="button" :href="edicao_centro_custo.link_painel" target="_blank" title="Abrir Painel de Chamadas" data-toggle="tooltip">
                                                <i class="fas fa-tv"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-6">
                                    <small class="text-muted">Link do Painel de Chamada</small>
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Gerar..." :value="edicao_centro_custo.link_totem" disabled>
                                        <div class="input-group-append" v-if="edicao_centro_custo.link_totem">
                                            <a class="btn btn-outline-primary" type="button" :href="edicao_centro_custo.link_totem" target="_blank" title="Totem para Check-In" data-toggle="tooltip">
                                                <i class="fas fa-tv"></i>
                                            </a>
                                            <a class="btn btn-outline-primary" type="button" :href="edicao_centro_custo.link_totem + '&semagenda=1'" target="_blank" title="Sem Agenda" data-toggle="tooltip">
                                                <i class="fa-solid fa-calendar-xmark"></i>
                                            </a>
                                            <a class="btn btn-outline-primary" type="button" :href="edicao_centro_custo.link_totem + '&semagenda=1&bt=1'" target="_blank" title="Apenas Botões" data-toggle="tooltip">
                                                <i class="fa-solid fa-circle-dot"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Atendimento de Urgência"
                                        v-model="edicao_centro_custo.fl_emergencia" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Recepção sem atendimento agendado (Check-In sem Agendamento)"
                                        v-model="edicao_centro_custo.fl_sem_agenda" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Chamada realizada sempre por senha"
                                        v-model="edicao_centro_custo.fl_chamada_senha" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Recepção para Check-In via API (Integração) na Unidade"
                                        v-model="edicao_centro_custo.fl_checkin_remoto" />
                                </div>
                            </div>

                            <div class="form-row" v-if="edicao_unidade.tem_apoiados">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Preenchimento do Apoiado Obrigatório"
                                        v-model="edicao_centro_custo.fl_apoiado_obrig" />
                                </div>
                            </div>

                            <div class="form-row" v-if="edicao_centro_custo.fl_chamada_senha">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        icon="fa-solid fa-tag fa-fw"
                                        sizing="sm"
                                        placeholder="Selecione a etiqueta..."
                                        type="select"
                                        :optionsList="etiquetas"
                                        optionsData="id_etiqueta_layout"
                                        required
                                        :validate="validate"
                                        v-model="edicao_centro_custo.id_etiqueta_layout" />
                                </div>
                            </div>

                            <div class="alert alert-secondary" v-if="edicao_centro_custo.fl_chamada_senha">
                                Ao indicar chamada pela senha, deve-se selecionar o layout de etiqueta desejado, e deve ter impressora configurada associada aos paineis de retirada de senha (check-in).
                            </div>

                            <div class="row mt-3 mb-3" v-if="!edicao_centro_custo.subs || !edicao_centro_custo.subs.length">
                                <div class="col col-12 col-md-8">
                                    <az-input
                                        label="Recepção na qual essa recepção está localizada (opcional)"
                                        type="select"
                                        :optionsList="lista_recepcoes"
                                        optionsData="id_recepcao"
                                        v-model="edicao_centro_custo.id_recepcao_mae" />
                                    <div class="text-muted small">Deve ser preenchido quando a recepção está inserida dentro de outra recepção no mesmo local, como uma subrecepção. Caso não seja o caso, deixar o campo em branco.</div>
                                </div>
                                <div class="col col-12 col-md-4" v-if="edicao_centro_custo.id_recepcao_mae">
                                    <az-input
                                        label="Descrição para o TOTEM"
                                        type="text"
                                        placeholder="Nome da Recepção..."
                                        v-model="edicao_centro_custo.st_nome_totem" />
                                </div>
                            </div>

                            <div class="mb-3" v-else>
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Recepções vinculadas separadas fisicamente"
                                    v-model="edicao_centro_custo.fl_sub_separada" />

                                <div class="alert alert-info" v-if="edicao_centro_custo.fl_sub_separada">
                                    Ao marcar essa opção, no totem para check-in, vai aparecer a seleção prévia da recepção, antes da retirada de senha.
                                </div>
                            </div>

                            <div class="mb-3">
                                <az-input
                                    type="textarea"
                                    label="Informações sobre Atendimento"
                                    rows="3"
                                    v-model="edicao_centro_custo.st_info_espelho" />
                            </div>

                            <div class="mb-3" v-if="( edicao_centro_custo.tipo == 'R' || edicao_centro_custo.id_recepcao )">
                                <az-input
                                    label ="Emitir a NF por Outra Unidade:"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="$util.unidades_com_tags(false, false).filter(item => item.id_unidade_operacao != edicao_unidade.id_unidade_operacao)"
                                    optionsData="id_unidade_operacao"
                                    v-model="edicao_centro_custo.id_unidade_operacao_nf" />
                            </div>

                            <!-- Filtros de Exibição da Recepção -->
                            <filtro-model v-model="edicao_centro_custo.filtros" :validate="validate" :opcoes="lista_opcoes_filtro"
                                />

                            <!-- Adicões -->
                            <div v-if="tem_recep_adicao">
                                <az-sub-title class="mt-3" title="Check-In sem Agendamento">
                                    <a href="#" class="card-link" @click="incluir_recep_adicao(edicao_centro_custo)">
                                        <i class="fas fa-plus mr-2"></i>
                                        Incluir
                                    </a>
                                </az-sub-title>
                                <div v-if="!lista_adicoes.length">
                                    Nenhum
                                </div>
                                <div v-for="(adicao, iax) in lista_adicoes" :key="iax" class="form-row">
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Título..."
                                            required
                                            :validate="validate"
                                            v-model="adicao.st_titulo">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" @click="adicao.excluido = true">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Selecione o Procedimento..."
                                            type="autocomplete"
                                            optionsMode="aql"
                                            service="procedimentos.index"
                                            :optionsParm="{ ativos: true, agenda: true }"
                                            required
                                            :validate="validate"
                                            v-model="adicao.procedimento" />

                                        <az-input 
                                            sizing="sm"
                                            placeholder="Operadora/Plano..."
                                            type="autocomplete" 
                                            optionsMode="aql"
                                            service="planos.index"
                                            :optionsSync="false"
                                            v-model="adicao.plano"
                                            :validate="validate" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Selecione o Profissional..."
                                            type="autocomplete"
                                            optionsMode="aql"
                                            service="medicos.index"
                                            :optionsParm="{
                                                ativos: true,
                                                agenda: true,
                                                id_procedimento: adicao.procedimento ? adicao.procedimento.id_procedimento : null
                                            }"
                                            required
                                            :validate="validate"
                                            v-model="adicao.medico" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Tipo..."
                                            type="select"
                                            :optionsList="[
                                                { id: 'A', search: 'Atendimento' },
                                                { id: 'O', search: 'Outro Consultório' },
                                                { id: 'R', search: 'Outro Recepção' },
                                                { id: 'T', search: 'Teleatendimento' },
                                            ]"
                                            optionsData="id"
                                            required
                                            :validate="validate"
                                            v-model="adicao.st_tipo">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="adicao.fl_direto = !adicao.fl_direto">
                                                        <i class="fa-solid fa-list-check fa-fw" v-if="!adicao.fl_direto" title="Permite check-in múltiplo"></i>
                                                        <i class="fa-solid fa-check fa-fw" v-else title="Permite check-in direto"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-1" v-if="1==0 && adicao.fl_preferencial">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Preferencial"
                                            v-model="adicao.fl_preferencial" />
                                    </div>
                                    <div class="col col-12 col-md-2" >
                                        <az-input
                                            sizing="sm"
                                            placeholder="Selecione a etiqueta..."
                                            type="select"
                                            :optionsList="etiquetas"
                                            optionsData="id_etiqueta_layout"
                                            :validate="validate"
                                            v-model="adicao.id_etiqueta_layout" />
                                    </div>
                                    <div class="col col-12 col-md-1">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Prefixo... Senha..."
                                            :validate="validate"
                                            v-model="adicao.st_prefixo_senha">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="adicao.fl_preferencial = !adicao.fl_preferencial">
                                                        <i class="fa-solid fa-p fa-fw" v-if="adicao.fl_preferencial" title="Atendimento preferencial"></i>
                                                        <i class="fa-solid fa-n fa-fw" v-else title="Atendimento não preferencial"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-1">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Ícone..."
                                            :validate="validate"
                                            v-model="adicao.st_icone">
                                        </az-input>
                                        <az-input
                                            sizing="sm"
                                            placeholder="Cor..."
                                            :validate="validate"
                                            type="select"
                                            :optionsList="[
                                                { id: 'warning', search: 'Amarelo' },
                                                { id: 'primary', search: 'Azul' },
                                                { id: 'light', search: 'Branco' },
                                                { id: 'info', search: 'Ciano' },
                                                { id: 'secondary', search: 'Cinza' },
                                                { id: 'dark', search: 'Preto' },
                                                { id: 'success', search: 'Verde' },
                                                { id: 'danger', search: 'Vermelho' },
                                            ]"
                                            optionsData="id"
                                            v-model="adicao.st_cor">
                                        </az-input>
                                    </div>
                                </div>
                                <pre v-if="1 == 0">{{ edicao_centro_custo }}</pre>
                            </div>

                            <div v-if="tem_recep_adicao">

                                <az-sub-title class="mt-3" title="Aviso de Tempo de Espera"></az-sub-title>

                                <az-input   
                                    type="checkbox-group"
                                    sizing="sm"
                                    label="Avisar quando o tempo máximo de espera na recepção for excedido"
                                    v-model="edicao_centro_custo.fl_aviso_tempo_espera" />

                                <div v-if="edicao_centro_custo.fl_aviso_tempo_espera" class="mt-3">

                                    <div v-if="!edicao_centro_custo.js_comunic_tempo_espera || !edicao_centro_custo.js_comunic_tempo_espera.length">
                                        Nenhum destino cadastrado
                                    </div>

                                    <div v-else-if="edicao_centro_custo.js_comunic_tempo_espera">
                                        <div class="form-row" v-for="(destino, idx) in edicao_centro_custo.js_comunic_tempo_espera" :key="idx">
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    type="select"
                                                    optionsMode="json"
                                                    :optionsList="[
                                                        { id: 'E', search: 'e-mail' },
                                                        { id: 'T', search: 'Telegram' },
                                                    ]"
                                                    optionsData="id"
                                                    :validate="validate"
                                                    required
                                                    v-model="destino.tipo" />
                                            </div>
                                            <div class="col col-12 col-md-5">
                                                <az-input
                                                    sizing="sm"
                                                    :type="destino.tipo == 'E' ? 'email' : 'number'"
                                                    v-if="destino.tipo"
                                                    :placeholder="destino.tipo == 'E' ? 'e-mail' : 'Id do Telegram'"
                                                    :validate="validate"
                                                    required
                                                    v-model="destino.conta">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend input-group-sm">
                                                            <button class="btn btn-outline-danger btn-sm" type="button" id="button-addon1" @click="remove_destino(idx)">
                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-4">
                                                <az-input
                                                    sizing="sm"
                                                    placeholder="Nome..."
                                                    :validate="validate"
                                                    v-model="destino.nome" />
                                            </div>
                                        </div>
                                    </div>

                                    <button type="button" class="btn btn-sm btn-outline-primary mt-3" @click="incluir_recep_destino()"> 
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>

                                </div>

                            </div>

                            <template v-if="edicao_centro_custo">
                                <az-sub-title class="mt-3" title="Recepção adicional para envio ao Painel de Chamada"></az-sub-title>
                                <az-input  
                                    sizing="sm"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    optionsData="id_recepcao"
                                    optionsDisplay="search"
                                    service="recepcaos.index"
                                    :optionsParm="{ filtros: true }"
                                    optionsName="recepcaos.chamada"
                                    placeholder="Recepção..."
                                    v-model="edicao_centro_custo.id_recepcao_chamada" />

                                <div class="small text-muted">
                                    Ao selecionar uma recepção, as chamadas serão exibidas também no painel de chamada dessa recepção.
                                </div>
                            </template>

                            <template v-if="edicao_centro_custo && atp_cc">
                                <az-sub-title class="mt-3" title="Centro de Custo Vinculado a Recepção"></az-sub-title>
                                <az-input  
                                    sizing="sm"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    optionsData="id_centro_custo"
                                    optionsDisplay="search"
                                    service="centro_custos.index"
                                    placeholder="Nenhum..."
                                    v-model="edicao_centro_custo.id_centro_custo_lanc" />

                                <div class="small text-muted" v-if="edicao_centro_custo.id_centro_custo_lanc">
                                    Ao selecionar um centro de custo, os lançamentos dessa recepção direcionarão para esse centro de custo.
                                </div>
                            </template>

                            <template v-if="false">
                                <az-sub-title class="mt-3" title="Token Totem/Painel Chamada"></az-sub-title>
                                <div class="row">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            label="Token"
                                            :edicao="false"
                                            v-model="edicao_centro_custo.st_token">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-primary" type="button" @click="regerar_token()">
                                                        <i class="fa-solid fa-retweet"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>
                            </template>

                            <br><br><br><br><br>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="centroCusto" :id="edicao_centro_custo.id_centro_custo" v-if="edicao_centro_custo.id_centro_custo" />
                        <az-audit-log-button model="recepcao" :id="edicao_centro_custo.id_recepcao" v-if="edicao_centro_custo.id_recepcao" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_centro_custo">{{ edicao_centro_custo.id_centro_custo || edicao_centro_custo.id_recepcao ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Local -->
        <div class="modal fade" id="localModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao_centro_custo && edicao_local">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ edicao_centro_custo.search }} / Local</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input label="Nome" required :validate="validate" v-model="edicao_local.st_local" />
                        <az-input label="Sigla" :validate="validate" v-model="edicao_local.st_sigla" />

                        <az-input class="mt-3" type="checkbox-group" label="Exibir no Mapa de Sala" :validate="validate" v-model="edicao_local.fl_exibir_mapa_sala" />
                        <az-input type="checkbox-group" label="Sala de Cirurgia" :validate="validate" v-model="edicao_local.fl_centro_cirurgico" :edicao="!edicao_local.fl_coleta_dom && !edicao_local.fl_infusao" /> 
                        <az-input type="checkbox-group" label="Poltrona de Infusão" :validate="validate" v-model="edicao_local.fl_infusao" :edicao="!edicao_local.fl_coleta_dom && !edicao_local.fl_centro_cirurgico && !edicao_local.fl_leito" />
                        <az-input type="checkbox-group" label="Leito" :validate="validate" v-model="edicao_local.fl_leito" :edicao="!edicao_local.fl_coleta_dom && !edicao_local.fl_infusao" />
                        <az-input type="checkbox-group" label="Coleta Domiciliar" :validate="validate" v-model="edicao_local.fl_coleta_dom" :edicao="!edicao_local.fl_infusao && !edicao_local.fl_leito && !edicao_local.fl_centro_cirurgico" /> 
                        <az-input type="checkbox-group" label="Local de execução de procedimentos em paralelo" :validate="validate" v-model="edicao_local.fl_sala_paralela" v-if="!edicao_local.fl_centro_cirurgico && !edicao_local.fl_infusao && !edicao_local.fl_leito && tem_local_paralelo" />
                        <az-input type="checkbox-group" label="Definir Disponibilidade da Sala" :validate="validate" v-model="edicao_local.fl_info_disp" v-if="edicao_local.fl_exibir_mapa_sala" @click="toggle_disp()" />

                        <div v-if="edicao_local.fl_leito">
                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input 
                                        sizing="sm" 
                                        type="select" 
                                        label="Regime de Internação"
                                        placeholder="Não informado..."
                                        :optionsList="[
                                            { id: '1', search: 'Hospitalar' }, 
                                            { id: '2', search: 'Hospital-Dia' }, 
                                            { id: '3', search: 'Domiciliar' }, 
                                        ]"
                                        optionsData="id"
                                        :validate="validate" 
                                        v-model="edicao_local.ch_leito_regime" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input 
                                        sizing="sm" 
                                        type="select" 
                                        label="Diária"
                                        placeholder="Selecione..."
                                        optionsMode="aql"
                                        optionsData="id_taxa"
                                        service="taxas.index"
                                        :optionsParm="{ ativos: true }"
                                        :validate="validate"
                                        v-model="edicao_local.id_taxa_diaria" />
                                </div>
                            </div>
                        </div>

                        <div v-if="edicao_local.fl_exibir_mapa_sala && edicao_local.fl_info_disp && edicao_local.js_disponibilidade">
                            <az-sub-title title="Disponibilidade" class="mt-3" />
                            <div class="form-row" v-for="(dia, idx) in edicao_local.js_disponibilidade" :key="idx">
                                <div class="col col-12 col-md-4">
                                    <az-input sizing="sm" type="checkbox-group" :label="dias[idx]" :validate="validate" v-model="dia.disp" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input sizing="sm" icon="fas fa-greater-than-equal" type="time" :validate="validate" :edicao="dia.disp" v-model="dia.de" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input sizing="sm" icon="fas fa-less-than-equal" type="time" :validate="validate" :edicao="dia.disp" v-model="dia.ate" />
                                </div>
                            </div>
                        </div>

                        <div v-if="edicao_local.fl_coleta_dom && edicao_local.regioes">
                            <az-sub-title title="Regiões" class="mt-3">
                                <a href="#" class="card-link" @click="incluir_local_regiao(edicao_local)">
                                    <i class="fas fa-plus mr-2"></i>
                                    Incluir
                                </a>
                            </az-sub-title>

                            <div v-for="(regiao, irx) in edicao_local.regioes" :key="irx">
                                <div class="form-row" v-if="!regiao.excluido">
                                    <div class="col col-12">
                                        <az-input
                                            required
                                            :validate="validate"
                                            type="select"
                                            placeholder="Selecione a Região..."
                                            :optionsList="lista_regioes"
                                            optionsData="id_regiao_cd"
                                            v-model="regiao.id_regiao_cd">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" @click="regiao.excluido = true">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="local" :id="edicao_local.id_local" v-if="edicao_local.id_local" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_local()">{{ edicao_local.id_local ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Operadoras -->
        <div class="modal fade" id="unidadeOperadorasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao_unidade">
                    <div class="modal-header">
                        <h5 class="modal-title">Operadoras: {{ edicao_unidade.search }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!lista_unidade_operadora || !lista_unidade_operadora.length" />

                        <template v-else>
                            <div>
                                <az-input
                                    type="checkbox-group"
                                    label="Todas"
                                    v-model="todas_operadoras" />
                            </div>

                            <div v-for="(operadora, iuox) in lista_unidade_operadora" :key="iuox">
                                <az-input
                                    type="checkbox-group"
                                    :label="operadora.search"
                                    v-model="operadora.unidade_operadora.fl_ativo" />
                            </div>
                        </template>

                        <pre v-if="false">{{ lista_unidade_operadora }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_unidade_operadoras()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Validação Particular -->
        <div class="modal fade" id="unidadeOperacaoPlanosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content" v-if="edicao_unidade">
                    <div class="modal-header">
                        <h5 class="modal-title">Particulares: {{ edicao_unidade.search }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!lista_unidade_operacao_planos || !lista_unidade_operacao_planos.length" />

                        <template v-else>
                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="checkbox-group"
                                        label="Todos"
                                        v-model="todos_particulares" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="label"
                                        label="Emissão da Nota Fiscal" />
                                </div>
                            </div>

                            <div class="form-row" v-for="(plano, iuox) in lista_unidade_operacao_planos" :key="iuox">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="checkbox-group"
                                        :label="plano.search"
                                        v-model="plano.unidade_operacao_plano.fl_ativo" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="plano.unidade_operacao_plano.fl_ativo">
                                    <az-input
                                        icon="fa-solid fa-file-invoice-dollar"
                                        type="select"
                                        placeholder="Emissão Nota Fiscal..."
                                        :optionsList="$util.unidades_com_tags(false, false)"
                                        optionsData="id_unidade_operacao"
                                        v-model="plano.unidade_operacao_plano.id_unidade_operacao_nf" />
                                </div>
                            </div>
                        </template>

                        <pre v-if="false">{{ lista_unidade_operacao_planos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_unidade_operacao_planos()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <procedimento-lista ref="proclista" info="Procedimentos não realizados na unidade" />

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import CadastroTelefones from '../../shared/CadastroTelefones.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import AzSingleImageLoader from '../../../components/util/AzSingleImageLoader.vue';
import Multiselect from 'vue-multiselect';
import ProcedimentoLista from '../../shared/ProcedimentoLista.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';

export default {
    data () {
        return {
            dados: null,
            edicao_unidade: null,
            edicao_centro_custo: null,
            edicao_local: null,
            validate: false,
            viewMode: 'A',
            tem_recep_adicao: false,
            tem_local_paralelo: false,
            lista_unidade_operadora: [],
            lista_unidade_operacao_planos: [],
            natureza_operacao: [
                 { id: "1", search: "Tributação no município" },
                 { id: "2", search: "Tributação fora do município" },
                 { id: "3", search: "Isenção" },
                 { id: "4", search: "Imune" },
                 { id: "5", search: "Exigibilidade suspensa por decisão judicial" },
                 { id: "6", search: "Exigibilidade" },
            ],
            regime_tributacao: [
                 { id: "1", search: "Microempresa municipal" },
                 { id: "2", search: "Estimativa" },
                 { id: "3", search: "Sociedade de profissionais" },
                 { id: "4", search: "Cooperativa" },
                 { id: "5", search: "Microempresário Individual (MEI)" },
                 { id: "6", search: "Microempresário e Empresa de Pequeno Porte (ME EPP)" },
            ],
            regime_tributacao_novo: [
                 { id: "0", search: "Nenhum" },
                 { id: "1", search: "Ato Cooperado (Cooperativa)" },
                 { id: "2", search: "Estimativa" },
                 { id: "3", search: "Microempresa Municipal" },
                 { id: "4", search: "Notário ou Registrador" },
                 { id: "5", search: "Profissional Autônomo" },
                 { id: "6", search: "Sociedade de Profissionais" },
            ],
            regime_tributacao_sn: [
                 { id: "1", search: "1 - Regime de apuração dos tributos federais e municipal pelo SN" },
                 { id: "2", search: "2 – Regime de apuração dos tributos federais pelo SN e ISSQN  por fora do SN conforme respectiva legislação municipal do tributo" },
                 { id: "3", search: "3 – Regime de apuração dos tributos federais e municipal por fora do SN conforme respectivas legislações federal e municipal de cada tributo" },
            ],
            rps_tipo: [
                 { id: "1", search: "RPS" },
                 { id: "2", search: "Nota Fiscal Conjugada (Mista)" },
                 { id: "3", search: "Cupom" },
            ],
            op_simples_nacional: [
                 { id: "1", search: "Não Optante" },
                 { id: "2", search: "Optante - Microempreendedor Individual (MEI)" },
                 { id: "3", search: "Optante - Microempresa ou Empresa de Pequeno Porte (ME/EPP)" },
            ],
            servico_nfse: [
                 { id: "1", search: "PowerP" },
                 { id: "2", search: "Klingo 1 (Recife, Feira, SAJ, Lauro de Freitas, Camaçari, Aracaju)" },
                 { id: "3", search: "Klingo 2 (Guarulhos, São Paulo)" },
                 { id: "4", search: "Klingo 3 (São Paulo) - Não usar" },
                 { id: "5", search: "Klingo 4 NFSe Nacional" },
            ],
            situacao_tributaria: [
                { id : "0", search: "0 - Nenhum" },
                { id : "1", search: "1 - Operação Tributável com Alíquota Básica" },
                { id : "2", search: "2 - Operação Tributável com Alíquota Diferenciada" },
                { id : "3", search: "3 - Operação Tributável com Alíquota por Unidade de Medida de Produto" },
                { id : "4", search: "4 - Operação Tributável monofásica - Revenda a Alíquota Zero" },
                { id : "5", search: "5 - Operação Tributável por Substituição Tributária" },
                { id : "6", search: "6 - Operação Tributável a Alíquota Zero" },
                { id : "7", search: "7 - Operação Tributável da Contribuição" },
                { id : "8", search: "8 - Operação sem Incidência da Contribuição" },
                { id : "9", search: "9 - Operação com Suspensão da Contribuição " },
            ],

            // Antiga antes da reforma
            // situacao_tributaria: [
            //      { id: "0", search: "0 - Tributada integralmente" },
            //      { id: "5", search: "5 - Tributada integralmente e sujeito ao regime de substituição tributária pelo agenciador ou intermediário da prestação do serviço" },
            //      { id: "8", search: "8 - Tributada com redução da base de cáculo ou alíquota" },
            //      { id: "12", search: "12 - Isenta ou imune" },
            //      { id: "13", search: "13 - Não tributada" },
            //      { id: "14", search: "14 - Tributada por meio de imposto fixo" },
            //      { id: "15", search: "15 - Não tributada em razão dos destinos dos bens ou objetos - Mercadorias para industrialização ou comercialização" },
            //      { id: "16", search: "16 - Não tributada em razão do diferimento da prestação do serviço" },
            //       
            // ],
            chave: "",
            item: null,
            exibir_dados_certificado: false,
            options_classes: [],
            dias: [
                'Domingo',
                'Segunda',
                'Terça',
                'Quarta',
                'Quinta',
                'Sexta',
                'Sábado',
            ],
            etiquetas: null,
            tem_ipsign: false,
            search: "",
            lista_regioes: [], 
            atp_cc: false, 
        }
    },

    components: {
        ConfigMainTitle,
        AzInput,
        AzSubTitle,
        CadastroEndereco,
        CadastroTelefones,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel,
        AzSingleImageLoader,
        Multiselect, 
        ProcedimentoLista,
        Formulario
    },

    computed: {
        lista_recepcoes: function () {
            if ( !this.edicao_unidade )
                return [];

            return this.edicao_unidade.recepcaos.filter(item => !item.id_recepcao_mae && item.fl_ativo);
        },

        todas_operadoras: {
            get() {
                return !this.lista_unidade_operadora.find(item => !item.unidade_operadora.fl_ativo);
            },

            set(valor) {
                if ( !valor ) {
                    if ( this.lista_unidade_operadora.find(item => !item.unidade_operadora.fl_ativo) )
                        return;
                }

                this.lista_unidade_operadora.forEach(item => {
                    item.unidade_operadora.fl_ativo = valor;
                });
            }
        },

        todos_particulares: {
            get() {
                return !this.lista_unidade_operacao_planos.find(item => !item.unidade_operacao_plano.fl_ativo);
            },

            set(valor) {
                if ( !valor ) {
                    if ( this.lista_unidade_operacao_planos.find(item => !item.unidade_operacao_plano.fl_ativo) )
                        return;
                }

                this.lista_unidade_operacao_planos.forEach(item => {
                    item.unidade_operacao_plano.fl_ativo = valor;
                });
            }
        },

        lista_opcoes_filtro: function () {
            let opcoes = [
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'},
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'},
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'},
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true},
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'tag-medico', search:'Classificação do Prestador', service: 'medicos.index', tag: true},
                {id:'App\\azure\\local', search:'Local', service: 'locals.index',
                    name: this.edicao_unidade ? this.edicao_unidade.id_unidade_operacao : '',
                    parms: { id_unidade_operacao: this.edicao_unidade ? this.edicao_unidade.id_unidade_operacao : '' },
                },
            ];

            return _.orderBy(opcoes, 'search');
        },

        lista_adicoes: function () {
            if ( !this.edicao_centro_custo || !this.edicao_centro_custo.adicoes )
                return [];

            return this.edicao_centro_custo.adicoes.filter(item => !item.excluido);
        },

        lista_exibicao: function () {
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);

            return this.dados.filter (item => ( !this.search || reg.test(JSON.stringify(item)) ));
        }
    },

    methods: {
        regerar_token () { 
            if ( this.edicao_centro_custo.st_token ) { 
                if ( !confirm('Confirma a geração de novo token para recepção?') ) { 
                    return;
                }
            }

            this.edicao_centro_custo.st_token = this.generateRandomString(32);
        },

        generateRandomString (length) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                const randomIndex = Math.floor(Math.random() * characters.length);
                result += characters[randomIndex];
            }
            return result;
        },

        remove_destino (idx) { 
            this.edicao_centro_custo.js_comunic_tempo_espera.splice(idx, 1);
        },

        incluir_recep_destino () { 
            if ( !this.edicao_centro_custo.js_comunic_tempo_espera ) { 
                this.edicao_centro_custo.js_comunic_tempo_espera = [];
            }

            this.edicao_centro_custo.js_comunic_tempo_espera.push({ 
                tipo: 'T',
                conta: '',
                nome: ''
            });
        },

        lista_procedimentos (unidade) { 
            this.$refs.proclista.abrir('unidadeOperacao', unidade.id_unidade_operacao);
        },

        incluir_local_regiao (local) { 
            local.regioes.push({
                id_local: local.id_local,
                id_regiao_cd: "", 
                id_local_regiao: null,
                excluido: false,
            });
        },

        editar_cnaes (uo) {
            $('.modal').modal('hide');

            this.$router.push({ name: 'c-unidade-cnae', params: { id_unidade_operacao: uo.id_unidade_operacao }});
        },

        toggle_disp () {
            if ( !this.edicao_local.js_disponibilidade ) {
                this.edicao_local.js_disponibilidade = [];

                for (let index = 0; index < 7; index++) {
                    this.edicao_local.js_disponibilidade.push({
                        disp: true,
                        de: '',
                        ate: ''
                    });
                }
            }
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.edicao_unidade.js_classes )
                this.edicao_unidade.js_classes = [];

            this.edicao_unidade.js_classes.push(newTag);
        },

        atualizar_unidade_operadoras () {
            this.$util.atualizar(this, {
                service: 'unidades',
                func: 'salvar_unidade_operadoras',
                dados: {
                    lista: this.lista_unidade_operadora,
                },
                modal: 'unidadeOperadorasModal',
                reload: true,
            });
        },

        atualizar_unidade_operacao_planos () {
            this.$util.atualizar(this, {
                service: 'unidades',
                func: 'salvar_unidade_operacao_planos',
                dados: {
                    lista: this.lista_unidade_operacao_planos,
                },
                modal: 'unidadeOperacaoPlanosModal',
                reload: true,
            });
        },

        editar_unidade_operacao_planos(unidade) {
            $('.modal').modal('hide');
            this.lista_unidade_operacao_planos = [];
            this.edicao_unidade = unidade;

            this.$util.load(this, {
                service: 'planos',
                func: 'index',
                parms: {
                    cadastro_unidade: true,
                    id_unidade_operacao: this.edicao_unidade.id_unidade_operacao,
                },
                loadTo: res => {
                    this.lista_unidade_operacao_planos = res;
                }
            });

            $('#unidadeOperacaoPlanosModal').modal('show');
        },

        editar_unidade_operadoras(unidade) {
            $('.modal').modal('hide');
            this.lista_unidade_operadora = [];
            this.edicao_unidade = unidade;

            this.$util.load(this, {
                service: 'operadoras',
                func: 'index',
                parms: {
                    cadastro_unidade: true,
                    id_unidade_operacao: this.edicao_unidade.id_unidade_operacao,
                },
                loadTo: res => {
                    this.lista_unidade_operadora = res;
                }
            });

            $('#unidadeOperadorasModal').modal('show');
        },

        incluir_recep_adicao (recep) {
            recep.adicoes.push({
                id_recepcao: recep.id_recepcao,
                id_recepcao_adicao: null,
                procedimento: "",
                medico: "",
                fl_preferencial: false,
                st_titulo: "",
                excluido: false,
                id_etiqueta_layout: null,
                st_tipo: 'A',
                fl_direto: false,
            });
        },

        gerar_link_painel () {
            this.$util.atualizar(this, {
                service: 'unidades',
                func: 'gerar_link_painel',
                dados: {
                    id_unidade_operacao: this.edicao_unidade.id_unidade_operacao,
                    id_recepcao: this.edicao_centro_custo ? this.edicao_centro_custo.id_recepcao : null, 
                },
                callback: res => {
                    this.edicao_unidade.link_painel = res.link;
                    this.edicao_centro_custo.link_painel = res.link;
                    this.edicao_centro_custo.st_token_painel = res.token; 

                    this.load();
                }
            });
        },

        filtrar_ativos(lista) {
            if ( !lista )
                return [];

            return lista.filter(item => this.viewMode == 'T' || item.fl_ativo);
        },
        toggle_status(service, item) {
            this.$util.toggle (this, {
                service: service,
                dados: { ...item },
            });
        },
        criar_unidade () {
            this.validate = false;
            this.edicao_unidade = null;

            this.$nextTick(() => { 
                this.edicao_unidade = {
                    endereco: {},
                    telefone_unidade_operacaos: []
                };
                $('#unidadeModal').modal('show');
            });
        },
        editar_unidade (item) {
            this.edicao_unidade = null;
            this.validate = false;

            this.$nextTick(() => { 
                this.edicao_unidade = _.cloneDeep(item);
                $('#unidadeModal').modal('show');
            });
        },
        criar_centro_custo (unidade) {
            this.validate = false;
            this.edicao_unidade = unidade;
            this.edicao_centro_custo = null; 

            this.$nextTick(() => {
                this.edicao_centro_custo = {
                    id_centro_custo: null,
                    tipo: "C",
                    id_unidade_operacao: unidade.id_unidade_operacao,
                    id_unidade: unidade.id_unidade,
                };
                $('#centroModal').modal('show');
            });
        },
        editar_centro_custo (unidade, centro) {
            this.edicao_centro_custo = null; 
            this.validate = false;
            this.edicao_unidade = unidade;

            this.$nextTick(() => {
                this.edicao_centro_custo = _.cloneDeep(centro);
                $('#centroModal').modal('show');
            });
        },
        criar_local (centro) {
            this.validate = false;
            this.edicao_centro_custo = centro;

            this.edicao_local = {
                id_local: null,
                id_centro_custo: centro.id_centro_custo,
                id_unidade: centro.id_unidade,
                fl_sala_paralela: false,
                fl_centro_cirurgico: false,
                fl_exibir_mapa_sala: true,
                fl_info_disp: false,
                fl_leito: false,
                fl_coleta_dom: false,
                regioes: [], 
                ch_leito_regime: "", 
            };

            $('#localModal').modal('show');
        },
        editar_local (centro, local) {
            this.validate = false;
            this.edicao_centro_custo = centro;
            this.edicao_local = _.cloneDeep(local);
            $('#localModal').modal('show');
        },
        atualizar_unidade() {
            this.$util.atualizar(this, {
                service: 'unidade_operacaos',
                dados: this.edicao_unidade,
                modal: 'unidadeModal',
                reload: true,
                callback: () => {
                    this.refresh_unidade();
                }
            });
        },
        atualizar_centro_custo() {
            let service = ( this.edicao_centro_custo.tipo == 'R' || this.edicao_centro_custo.id_recepcao ) ? 'recepcaos' : 'centro_custos';

            this.$util.atualizar(this, {
                service: service,
                dados: this.edicao_centro_custo,
                modal: 'centroModal',
                reload: true,
                callback: () => {
                    this.refresh_unidade();
                }
            });
        },
        atualizar_local() {
            this.$util.atualizar(this, {
                service: 'locals',
                dados: this.edicao_local,
                modal: 'localModal',
                callback: () => {
                    this.refresh_locais(this.edicao_centro_custo);
                    //this.refresh_unidade();
                }
            });
        },
        load () {
            this.$store.commit('loading', true);

            let query = { q: [
                {
                   name: 'unidade_operacaos.index',
                   id: 'unidades',
                   parms: {
                       cadastro: true,
                   }
                },
                {
                    name: 'configuracoes.show',
                    id: 'adicao',
                    parms: {
                        id: 4,
                    }
                },
                {
                    name: "configuracoes.index",
                    id: "local",
                    parms: {
                        where: {
                            st_slug: 'local-paralelo',
                            st_valor: '1',
                        },
                    },
                },
                {
                    name: "configuracoes.index",
                    id: "ipsign",
                    parms: {
                        where: {
                            st_slug: 'integracao-ipsign',
                            st_valor: '1',
                        },
                    },
                },
                {
                    name: 'etiqueta_layouts.index',
                    id: 'etiquetas',
                    parms: {
                        where: {
                            ch_tipo_impressao: 'S',
                            st_model_type: ['App\\azure\\marcacao', 'App\\azure\\atendimentoOutro'],
                        }
                    },
                },
                {
                    name: 'regiao_cds.index',
                    id: 'regioes',
                    parms: {
                        where: {
                            fl_ativo: 1,
                        }
                    },
                },

            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.unidades.status == 200 ) {
                        this.dados = res.data.unidades.data.map(item => {
                            if ( !item.endereco )
                                item.endereco = {};

                            return item;
                        });
                    }

                    if ( res.data.adicao.status == 200 ) {
                        this.tem_recep_adicao = ( res.data.adicao.data.st_valor == 1 );
                    }

                    if ( res.data.local.status == 200 ) {
                        this.tem_local_paralelo = ( res.data.local.data.length ? true : false );
                    }

                    if ( res.data.ipsign.status == 200 ) {
                        this.tem_ipsign = ( res.data.ipsign.data.length ? true : false );
                    }

                    if ( res.data.etiquetas.status == 200 ) {
                        this.etiquetas = ( res.data.etiquetas.data );
                    }

                    if ( res.data.regioes.status == 200 ) {
                        this.lista_regioes = ( res.data.regioes.data );
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

        },
        refresh_locais (centro) {
            this.$util.loadItem(this, {
                service: 'locals',
                func: 'index',
                parms: {
                    where: { id_centro_custo: centro.id_centro_custo },
                    cadastro: true, 
                },
            })
            .then(res => {
                console.log(res);
                this.edicao_centro_custo.locals = res;
            });
        },
        refresh_unidade () {
            this.$util.loadItem(this, {
                service: 'unidades',
                func: 'show',
                id: 1,
                with: ['unidadeOperacaos.recepcaos']
            })
            .then(res => {
                this.$store.commit("setUnidade", res);
            });
        },
    },

    mounted () {
        this.$store.commit('setBreadcrumb',
              [
                { name: "Configurações", path: "/cadastros" },
                { name: "Unidades, Centros de Custo", path: "/config/unidades" },
              ]);

        this.$util.loadItem(this, {
            service: 'unidade_operacaos',
            func: 'tags',
            configs: ['atend-proc-centro-custo'], 
        })
        .then(res => {
            this.options_classes = res;

            this.atp_cc = !!this.$store.state.contexto['atend-proc-centro-custo'];
        });

        this.load ();
    },

    updated () {
        $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>